import * as VideoService from '../../Utility/VideoService';
import { GenericHandlerConfig, GenericVideo, GenericVideoHandler } from './Generic';

export type ReachHandlerConfig = GenericHandlerConfig & {
    videoUuid: string;
};

export class ReachVideoHandler extends GenericVideoHandler {
    protected _type: string;
    protected _videoId: string;

    constructor(config: ReachHandlerConfig) {
        super(config);
        this._videoId = config.videoUuid;
        this._type = 'reach';
    }

    protected async _createNewPlayer(): Promise<GenericVideo> {
        this._videoUrl = await VideoService.getPathImmediately(this._videoId);
        return super._createNewPlayer();
    }
}
